import 'normalize.css'
import { arrRouter } from 'commons/routers'
import Footer from 'layouts/Footer'
import Header from 'layouts/Header'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import HeaderWallet from 'layouts/HeaderWallet'
import NotFound from 'pages/NotFound'
import { ActionContext } from 'controller/context/ActionProvider'
import HeaderStableCoin from 'layouts/LayoutStable/HeaderStable'
import FooterStableCoin from 'layouts/LayoutStable/FooterStable'
import HeaderNew from 'layouts/HeaderNew'
import TagManager from 'react-gtm-module'
import LayoutContainer from 'layouts/LayoutContainer'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import "keen-slider/keen-slider.min.css"

const tagManagerArgs = {
  gtmId: 'GTM-N23JJ8L2'
}

function App() {
  const { pathname } = useLocation()
  const { state } = useContext(ActionContext)

  const { isHideFt } = state

  const isWalletScreen = pathname === '/wallet'
  const isStableCoin = pathname === '/stablecoins'

  const [isLoadingFirst, setIsLoadingFirst] = useState(true)
  TagManager.initialize(tagManagerArgs)

  const renderHeader = useMemo(() => {
    switch (pathname) {
      case '/stablecoins':
        return <HeaderStableCoin />
      case '/wallet':
        return <HeaderWallet />
      default:
        return <HeaderNew />
    }
  }, [pathname])

  const renderFooter = useMemo(() => {
    switch (pathname) {
      case '/stablecoins':
        return <FooterStableCoin />
      case '/wallet':
        return null
      default:
        return <Footer />
    }
  }, [pathname])

  useEffect(() => {
    setTimeout(() => {
      setIsLoadingFirst(false)
    }, 2000)
  }, [])

  useEffect(() => {
    if (!isLoadingFirst) {
      window.scrollTo({
        top: 0,
      })
    }
  }, [pathname])

  // if (isLoadingFirst)
  //   return (
  //     <div className='loading-screen'>
  //       <span className='icon-web_logo icon-logo-loading'></span>
  //     </div>
  //   )

  useEffect(() => {
    if (isWalletScreen) {
      document.body.style.backgroundColor = '#1e1e1e'
    } else {
      document.body.style.backgroundColor = 'unset'
    }
  }, [isWalletScreen])

  return (
    <div className='App'>
      {/* {renderHeader} */}
      {/* {!isWalletScreen ? <Header /> : <HeaderWallet />} */}

      <LayoutContainer>
        <Routes>
          {arrRouter.map((item, i) => {
            return <Route path={item.path} element={item.element} />
          })}
          <Route path='*' element={<NotFound />} />
        </Routes>
      </LayoutContainer>

      {/* <Footer /> */}

      {/* {renderFooter} */}
    </div>
  )
}

export default App
